import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HttpcancelService {
  private pendingHTTPRequests = new Subject<void>();

  constructor() { }

  public cancelPendingRequests(): void {
    this.pendingHTTPRequests.next();
  }

  public onCancelPendingRequests(): Observable<void> {
    return this.pendingHTTPRequests.asObservable();
  }
}
